require('../../modules/es6.number.is-nan');
module.exports = require('../../modules/_core').Number.isNaN;



// WEBPACK FOOTER //
// ../node_modules/@babel/runtime-corejs2/node_modules/core-js/library/fn/number/is-nan.js